module.exports = __webpack_public_path__ + "img/040_innen_thumb.8544ac7f.jpg";